import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReactTable from 'react-table';
import 'react-table/react-table.css';

class Table extends Component {
	render() {
		// console.log("Render:", new Date().getTime());
		let table = null;
		if (this.props.data.length > 0) {
			table = <ReactTable 
				data={this.props.data}
				columns={this.props.headers}
				defaultPageSize={10}
				previousText= 'Previous Page'
				nextText='Next Page'
			/>;
		}
		return table;
	}
}

Table.propTypes = {
	headers: PropTypes.array.isRequired,
	data: PropTypes.array.isRequired,
};

export default Table;


// WEBPACK FOOTER //
// ./src/components/Table.js